<template>
    <v-row v-if="competence" :class="['kimsa-elevation', { 'readonly': readonly }]" :ripple="!readonly" @click="onClick"
        @mouseover="$emit('hover')" @mouseout="$emit('hover-out')">
        <v-col cols="3" class="pa-0">
            <div class="img-competence" :style="{ backgroundImage: `url('${competenceImg}')` }" />
        </v-col>
        <v-col cols="9" class="p-relative">
            <div class="name-competence text-truncate">
                {{ competence.versus }}
            </div>
            <div class="description-competence text-truncate">
                {{ $t('common.competence') }}
            </div>
            <div class="description-competence text-truncate">
                {{ competenceDay }}
            </div>
            <div v-if="studentId" class="description-competence text-truncate">
                {{ $t('competences.assigned_to', { name: studentName }) }}
            </div>
        </v-col>
    </v-row>
</template>

<script>

import { db, Timestamp } from '@/utils/Firebase'

export default {
    props: {
        competence: {
            type: Object,
            default: null,
        },
        studentId: {
            type: String,
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            student: null,
            minutes: 0,
        }
    },
    async mounted() {
        const vm = this
        await vm.getStudentData()
    },
    computed: {
        competenceImg(vm = this) {
            if (vm.student?.avatar) return vm.student?.avatar
            return vm.competence.img || vm.imgPlaceholder
        },
        studentName(vm = this) {
            return vm.student?.name || '...'
        },
        competenceDay(vm = this) {
            return vm.$moment(vm.competence.rawDate.full).format('DD-MM-YYYY')
        }
    },
    methods: {
        onClick() {
            const vm = this
            vm.$emit('click')
        },
        async getStudentData() {
            const vm = this
            if (!vm.studentId) return;
            let studentRef = await db.collection('users').doc(vm.studentId).get()
            vm.student = studentRef.data()
        },
    },
    watch: {
        studentId() {
            this.getStudentData()
        },
    }
}
</script>

<style scoped>
.name-competence {
    font-size: 15px;
    font-weight: bold;
}

.description-competence {
    font-size: 13px;
    color: #999999;
}

.img-competence {
    background-position: 50% 50%;
    background-size: cover;
    border-radius: 4px 0 0 4px;
    background-color: rgba(1, 55, 46, 0.07);
    height: 100%;
}

.readonly {
    pointer-events: none;
}
</style>